/* vega-drawer-lazy.js — スマホ用メニュー（ドロワー）の中身を後から読み込む 2026-10-06

   ページを開いた時点では、ドロワーには第1階層のリンクだけが入っている
   （snippets/header-drawer.liquid の [data-vega-drawer-slot]）。
   中身（3階層すべて）は sections/vega-drawer-menu.liquid を Section Rendering API で取得して差し替える。

   読み込むタイミング:
     - 画面幅 990px 未満（ドロワーを使う幅）は、ページの読み込みが終わって手が空いたとき
     - どの幅でも、メニューボタンに触れた（押し始めた）とき
   失敗したときは第1階層のリンクが残るので、メニューが空にはならない。

   開閉の動きは Dawn の MenuDrawer（assets/global.js）のまま。
   差し込んだ summary / button に、MenuDrawer が最初に付けるのと同じハンドラを付け直す。 */
(function () {
  var drawer = document.querySelector('header-drawer');
  if (!drawer) return;
  var slot = drawer.querySelector('[data-vega-drawer-slot]');
  if (!slot) return;

  var state = 'idle';
  var pending = null;

  function bind(nav) {
    if (typeof drawer.onSummaryClick !== 'function' || typeof drawer.onCloseButtonClick !== 'function') return false;
    nav.querySelectorAll('summary').forEach(function (summary) {
      summary.addEventListener('click', drawer.onSummaryClick.bind(drawer));
    });
    nav.querySelectorAll('button').forEach(function (button) {
      button.addEventListener('click', drawer.onCloseButtonClick.bind(drawer));
    });
    return true;
  }

  function load() {
    if (state !== 'idle') return pending;
    state = 'loading';
    var url = window.location.pathname + '?sections=vega-drawer-menu';
    pending = fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (data) {
        var html = data && data['vega-drawer-menu'];
        if (!html) throw new Error('empty');
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var nav = holder.querySelector('.menu-drawer__navigation');
        if (!nav) throw new Error('no nav');
        if (!bind(nav)) throw new Error('MenuDrawer not ready');
        slot.replaceWith(nav);
        state = 'done';
      })
      .catch(function () {
        // 第1階層のリンクを残したままにする。次にボタンに触れたらもう一度試す。
        state = 'idle';
      });
    return pending;
  }

  var toggle = drawer.querySelector('summary');
  if (toggle) {
    ['pointerdown', 'touchstart', 'focus', 'mouseenter'].forEach(function (type) {
      toggle.addEventListener(type, load, { passive: true });
    });
  }

  function whenIdle() {
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(load, { timeout: 3000 });
    } else {
      setTimeout(load, 1500);
    }
  }

  if (document.readyState === 'complete') {
    whenIdle();
  } else {
    window.addEventListener('load', whenIdle, { once: true });
  }
})();
